import { html } from 'lit-all'

const chevron = html`
  <svg
    aria-hidden="true"
    focusable="false"
    fill="none"
    width="11"
    class="icon icon-chevron-right  icon--direction-aware"
    viewBox="0 0 10 10"
  >
    <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
  </svg>
`

const filter = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
  >
    <line
      y1="3.75"
      x2="16"
      y2="3.75"
      stroke="currentColor"
      stroke-width="1.5"
    ></line>
    <line
      y1="10.75"
      x2="16"
      y2="10.75"
      stroke="currentColor"
      stroke-width="1.5"
    ></line>
    <circle
      cx="6.19922"
      cy="3.5"
      r="2.5"
      fill="white"
      stroke="currentColor"
    ></circle>
    <circle
      cx="10.1992"
      cy="10.5"
      r="2.5"
      fill="white"
      stroke="currentColor"
    ></circle>
  </svg>
`

const close = html`
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" viewBox="0 0 18 17">
    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z"
      fill="currentColor">
  </svg>
`
const caret = html`
  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
      fill="currentColor">
  </svg>
`
const play = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M23 14.5L10.25 21.8612L10.25 7.13878L23 14.5Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`
const pause = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M10 7L10 22"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M20 7L20 22"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
`

const mute = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M6 14.3078C6 13.2032 6.89543 12.3078 8 12.3078H10.6286C10.8682 12.3078 11.0998 12.2218 11.2814 12.0654L14.3473 9.42401C14.9955 8.86559 16 9.32608 16 10.1816V19.8186C16 20.6742 14.9955 21.1346 14.3473 20.5762L11.2814 17.9348C11.0998 17.7784 10.8682 17.6924 10.6286 17.6924H8C6.89543 17.6924 6 16.797 6 15.6924V14.3078Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M19 17.5L21.5 15M21.5 15L24 12.5M21.5 15L24 17.5M21.5 15L19 12.5"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
`

const muted = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M10 14.3078C10 13.2032 10.8954 12.3078 12 12.3078H14.6286C14.8682 12.3078 15.0998 12.2218 15.2814 12.0654L18.3473 9.42401C18.9955 8.86559 20 9.32608 20 10.1816V19.8186C20 20.6742 18.9955 21.1346 18.3473 20.5762L15.2814 17.9348C15.0998 17.7784 14.8682 17.6924 14.6286 17.6924H12C10.8954 17.6924 10 16.797 10 15.6924V14.3078Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
`

const search = html`
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    width="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M10.364 3a7.364 7.364 0 1 0 0 14.727 7.364 7.364 0 0 0 0-14.727Z"
      stroke="currentColor"
      stroke-width="1"
      stroke-miterlimit="10"
    />
    <path
      d="M15.857 15.858 21 21.001"
      stroke="currentColor"
      stroke-width="1"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
`

const navigationArrow = html`
  <svg
    aria-hidden="true"
    focusable="false"
    fill="none"
    width="16"
    class="icon icon-arrow-right  icon--direction-aware"
    viewBox="0 0 16 18"
  >
    <path
      d="m5 17 8-8-8-8"
      stroke="currentColor"
      stroke-linecap="square"
    ></path>
  </svg>
`

const plus = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M7 1.75C7 5.8505 7 8.14949 7 12.25"
      stroke="#5812CD"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.25 7C8.1495 7 5.85051 7 1.75 7"
      stroke="#5812CD"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`

const minus = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M12.25 7C8.1495 7 5.85051 7 1.75 7"
      stroke="#5812CD"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`

const edit = html`
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.6238 3.2827L9.74983 0.871184L8.71632 2.10287L11.5903 4.51438L12.6238 3.2827ZM11.7955 4.68663L11.6233 4.89191L4.21649 13.719L4.04424 13.9243L3.98412 13.8738L1.20792 14.1167L1.07444 14.1284L1.06276 13.9949L0.819876 11.2187L0.759751 11.1682L0.932002 10.963L8.33879 2.1359L8.51104 1.93062L9.54455 0.698933L9.7168 0.493652L9.92208 0.665903L12.796 3.07742L13.0013 3.24967L12.829 3.45495L11.7955 4.68663ZM8.54407 2.30815L1.13728 11.1352L4.01121 13.5467L11.418 4.71966L8.54407 2.30815ZM1.31804 13.8381L1.11019 11.4623L3.6938 13.6302L1.31804 13.8381Z"
      fill="#55565A"
      stroke="#55565A"
      stroke-width="0.4"
    />
  </svg>
`

const deleteIcon = html`
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4326 1L0.574219 10.8583L10.4326 1Z"
      stroke="#55565A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M10.29 10.8583L0.431641 1L10.29 10.8583Z"
      stroke="#55565A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
`

const heart = html`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.41447 12.46L2.40878 12.4544L2.40419 12.4502C-0.136587 9.94345 -0.134729 5.88741 2.40976 3.38296L2.40984 3.38289C4.95942 0.87237 9.09844 0.87237 11.648 3.38289L11.9987 3.72818L12.3495 3.38304C14.9015 0.872238 19.0407 0.872452 21.5902 3.38289L21.5902 3.38296C24.1361 5.88875 24.1366 9.94778 21.5917 12.4542C21.5912 12.4547 21.5907 12.4552 21.5902 12.4556L21.5149 12.5285L21.5149 12.5285L21.5117 12.5316L12 21.8957L2.41447 12.46Z"
      stroke="#5812CD"
    />
  </svg>
`

const shop = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
  >
    <path
      d="M14.0483 9.0521V5.28727C14.0483 3.26338 12.2764 1.62268 10.0906 1.62268C7.90476 1.62268 6.13281 3.26338 6.13281 5.28727V9.0521"
      stroke="white"
      stroke-width="1.29705"
      stroke-linecap="round"
    />
    <rect
      x="1.55469"
      y="9.18774"
      width="16.8889"
      height="13.4573"
      stroke="white"
      stroke-width="1.29705"
      stroke-linejoin="round"
    />
  </svg>
`

const carouselCaret = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M18.4141 23.8333L7.58073 13L18.4141 2.16665"
      stroke="black"
      stroke-width="2.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`

const arrowShaftRight = html`
  <svg
    class="icon icon-arrow-w-shaft"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.2578 18.7134C10.2529 13.9109 14.0297 10.014 18.6934 10.0093"
      stroke="white"
      stroke-width="1.73913"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.2403 1.32211C10.2451 6.12458 14.0297 10.014 18.6934 10.0093"
      stroke="white"
      stroke-width="1.73913"
      stroke-linecap="round"
    />
    <path
      d="M18.6934 10.0093L1.30206 10.0267"
      stroke="white"
      stroke-width="1.73913"
      stroke-linecap="round"
    />
  </svg>
`

const arrowShaftLeft = html`
  <svg
    class="icon icon-arrow-w-shaft icon-arrow-w-shaft-left"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    version="1.1"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M10.2578 18.7134C10.2529 13.9109 14.0297 10.014 18.6934 10.0093"
      stroke="white"
      stroke-width="1.73913"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M10.2403 1.32211C10.2451 6.12458 14.0297 10.014 18.6934 10.0093"
      stroke="white"
      stroke-width="1.73913"
      stroke-linecap="round"
    ></path>
    <path
      d="M18.6934 10.0093L1.30206 10.0267"
      stroke="white"
      stroke-width="1.73913"
      stroke-linecap="round"
    ></path>
  </svg>
  <style>
    .icon-arrow-w-shaft-left {
      transform: scaleX(-1);
      -ms-transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
      -moz-transform: scaleX(-1);
      -o-transform: scaleX(-1);
    }
  </style>
`

const twoFingerSize = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M3.79099 2.66038C3.79088 3.82563 3.79099 9.6051 3.79099 9.6051C2.72134 9.6051 2.36475 10.1847 2.36475 10.8089C2.36475 11.4331 2.36475 15 6.91074 15C10.5475 15 11.635 12.7707 11.635 8.03405C11.635 8.03405 11.6351 7.78325 11.635 6.52883C11.6349 5.2744 9.674 5.40673 9.674 6.52883V7.11228L9.67395 6.04892C9.67385 4.7945 7.71298 4.92682 7.71298 6.04892V8.13376L7.71293 1.85783C7.71283 0.692581 5.75196 0.735732 5.75196 1.85784V2.66039C5.75196 1.53828 3.79109 1.49513 3.79099 2.66038Z"
      fill="white"
    />
    <path
      d="M3.79099 11.0764C3.79099 11.0764 3.79088 3.82563 3.79099 2.66038C3.79109 1.49513 5.75196 1.53828 5.75196 2.66038V8.13376M7.71293 8.08917C7.71293 8.08917 7.71304 3.02309 7.71293 1.85783C7.71283 0.692581 5.75196 0.735732 5.75196 1.85784V7.3391M9.67395 8C9.67395 8 9.67406 7.30335 9.67395 6.04892C9.67385 4.7945 7.71298 4.92682 7.71298 6.04892V8.13376M9.674 8.13376V6.52883C9.674 5.40673 11.6349 5.2744 11.635 6.52883C11.6351 7.78325 11.635 8.03405 11.635 8.03405C11.635 12.7707 10.5475 15 6.91074 15C2.36475 15 2.36475 11.4331 2.36475 10.8089C2.36475 10.1847 2.67673 9.6051 3.74637 9.6051"
      stroke="black"
      stroke-width="0.75"
      stroke-linecap="round"
    />
  </svg>
`

const threeFingerSize = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="14"
  height="16"
  viewBox="0 0 14 16"
  fill="none"
>
  <path
    d="M3.79099 9.6051C3.79099 9.6051 3.79088 3.82563 3.79099 2.66038C3.79109 1.49513 5.75196 1.53828 5.75196 2.66039V1.85784C5.75196 0.735732 7.71283 0.692581 7.71293 1.85783L7.71298 8.13376V2.83873C7.71298 1.71663 9.67385 1.5843 9.67395 2.83873C9.67401 3.57057 9.67402 5.25074 9.67401 6.52361C9.68009 5.40632 11.6349 5.27635 11.635 6.52883C11.6351 7.78325 11.635 8.03405 11.635 8.03405C11.635 12.7707 10.5475 15 6.91074 15C2.36475 15 2.36475 11.4331 2.36475 10.8089C2.36475 10.1847 2.72134 9.6051 3.79099 9.6051Z"
    fill="white"
  />
  <path
    d="M3.79099 11.0764C3.79099 11.0764 3.79088 3.82563 3.79099 2.66038C3.79109 1.49513 5.75196 1.53828 5.75196 2.66038V8.13376M7.71293 8.08917C7.71293 8.08917 7.71304 3.02309 7.71293 1.85783C7.71283 0.692581 5.75196 0.735732 5.75196 1.85784V7.3391M9.67395 8C9.67395 8 9.67406 4.09315 9.67395 2.83873C9.67385 1.5843 7.71298 1.71663 7.71298 2.83873V8.13376M9.674 8.13376V6.52883C9.674 5.40673 11.6349 5.2744 11.635 6.52883C11.6351 7.78325 11.635 8.03405 11.635 8.03405C11.635 12.7707 10.5475 15 6.91074 15C2.36475 15 2.36475 11.4331 2.36475 10.8089C2.36475 10.1847 2.67673 9.6051 3.74637 9.6051"
    stroke="black"
    stroke-width="0.75"
    stroke-linecap="round"
  />
</svg>`

const fourFingerSize = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="14"
  height="16"
  viewBox="0 0 14 16"
  fill="none"
>
  <path
    d="M3.5073 9.6051C3.5073 9.6051 3.50719 3.82563 3.5073 2.66038C3.5074 1.49513 5.46827 1.53828 5.46827 2.66039V1.85784C5.46827 0.735732 7.42914 0.692581 7.42924 1.85783L7.42929 8.13376V2.83873C7.42929 1.71663 9.39016 1.5843 9.39026 2.83873C9.39029 3.18105 9.39031 3.73086 9.39031 4.34943C9.39466 3.23076 11.3512 3.10012 11.3513 4.35315C11.3514 5.60758 11.3513 8.03405 11.3513 8.03405C11.3513 12.7707 10.2639 15 6.62705 15C2.08105 15 2.08105 11.4331 2.08105 10.8089C2.08105 10.1847 2.43765 9.6051 3.5073 9.6051Z"
    fill="white"
  />
  <path
    d="M3.5073 11.0764C3.5073 11.0764 3.50719 3.82563 3.5073 2.66038C3.5074 1.49513 5.46827 1.53828 5.46827 2.66039V8.13376M7.42924 8.08917C7.42924 8.08917 7.42935 3.02309 7.42924 1.85783C7.42914 0.692581 5.46827 0.735732 5.46827 1.85784V7.3391M9.39026 8C9.39026 8 9.39036 4.09315 9.39026 2.83873C9.39016 1.5843 7.42929 1.71663 7.42929 2.83873V8.13376M9.39031 8.13376V4.35316C9.39031 3.23105 11.3512 3.09873 11.3513 4.35315C11.3514 5.60758 11.3513 8.03405 11.3513 8.03405C11.3513 12.7707 10.2639 15 6.62705 15C2.08105 15 2.08105 11.4331 2.08105 10.8089C2.08105 10.1847 2.39303 9.6051 3.46268 9.6051"
    stroke="black"
    stroke-width="0.75"
    stroke-linecap="round"
  />
</svg>`

export {
  chevron,
  filter,
  close,
  caret,
  play,
  pause,
  mute,
  muted,
  search,
  navigationArrow,
  plus,
  minus,
  edit,
  deleteIcon,
  heart,
  shop,
  carouselCaret,
  arrowShaftRight,
  arrowShaftLeft,
  twoFingerSize,
  threeFingerSize,
  fourFingerSize,
}
